
import React from "react";

interface SectionHeaderProps {
  number: string | number;
  title: string;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ number, title }) => {
  return (
    <h3 className="text-xl font-semibold text-heaven-gold mb-3 text-left">
      {number}. {title}
    </h3>
  );
};

export default SectionHeader;
